import { useState } from 'react'
import InputField from '../inputField'
import Dropdown, { type selectOption } from '#app/components/common/dropdown'
import clsx from 'clsx'
import { chainOptions } from '#app/utils/misc'
import { CollectionNFTInputType } from '#app/utils/templates/utils/templateTypes.js'

export type ContractFullInputData = {
	contract: string
	chain: string
	type: 'smartContractFull'
	inputSelector: string
}

// FILTER OUT SOLANA BECAUSE IT DOESNT SUPPORT SEQUENTIAL TOKENS
export const chainSelectionOptions = chainOptions.filter(
	chain => chain.name !== 'Solana',
)

const ContractFullInput = ({
	name = 'CollectionNFTs',
	id,
	slug,
	onChange,
	errorFields,
	inputData,
	isInactive = false,
}: {
	name: string
	onChange: (val: CollectionNFTInputType, key?: string) => void
	id: string
	slug: string
	isInactive?: boolean
	inputData?: ContractFullInputData
	errorFields?: { [key: string]: string }
}) => {
	const [selectedChain, setSelectedChain] = useState<selectOption | null>(
		inputData && inputData.chain
			? chainSelectionOptions.find(
					chainOption => chainOption.slug === inputData.chain,
				) || null
			: null,
	)
	const [contractAddress, setContractAddress] = useState(
		inputData && inputData.contract ? inputData.contract : '',
	)

	const handleChainChange = (selected: selectOption) => {
		setSelectedChain(selected)
		onChange(
			{
				contract: contractAddress,
				chain: selected.slug,
				type: 'smartContractFull' as ContractFullInputData['type'],
				inputSelector: `nfts-${id}-${slug}`,
			},
			'chain',
		)
	}

	const handleChange = (key: string, val: string) => {
		if (key === 'contract') {
			setContractAddress(val)
		}
		onChange(
			{
				contract: val,
				chain: selectedChain?.slug || '',
				type: 'smartContractFull' as ContractFullInputData['type'],
				inputSelector: `nfts-${id}-${slug}`,
			},
			key,
		)
	}

	return (
		<div className={clsx('flex w-full flex-col')}>
			<Dropdown
				containerClasses="mb-2"
				additionalClasses={clsx(
					'h-12',
					errorFields && errorFields.chain ? 'border-red dark:border-red' : '',
				)}
				options={chainSelectionOptions}
				title="Select a Chain"
				placeholder="Select a Chain"
				selected={selectedChain}
				onSelectionChange={(selection: any) => handleChainChange(selection)}
			/>
			<input
				type="string"
				name={`nfts-${id}-${slug}-chain`}
				id={`nfts-${id}-${slug}-chain`}
				hidden={true}
				readOnly={true}
				value={selectedChain ? selectedChain.slug : ''}
			/>
			<InputField
				name="Contract Address"
				type="string"
				id={`nfts-${id}-${slug}-contract`}
				placeholder="Enter Contract Address"
				containerWidth="100%"
				displayName={true}
				value={contractAddress}
				onChange={e => handleChange('contract', e.currentTarget.value)}
				isError={errorFields && errorFields.contract ? true : false}
				helper={errorFields && errorFields.contract ? errorFields.contract : ''}
			/>
		</div>
	)
}

export default ContractFullInput
